export default "__VITE_ASSET__B71j8$4S__"